import vueWrapper from "../../utils/vue-wrapper"
import app from './app.vue';
import commonStore from '../global/common-store';

export default () => {
  vueWrapper(app, "collection-build-your-kit", "#collectionBuildYourKitData", commonStore);
}
